(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-brand-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('famiware-brand-tabs')) {
    customElements.define('famiware-brand-tabs', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.index = 0;
        this.addEventListener('click', event => {
          const tab = event.target.closest('[role="tab"]');
          const arrow = event.target.closest('[data-step]');
          if (tab && this.contains(tab)) this.select(Number(tab.dataset.index));
          if (arrow && this.contains(arrow)) this.select(this.index + Number(arrow.dataset.step));
        }, options);
        this.addEventListener('keydown', event => {
          if (!event.target.closest('[role="tab"]')) return;
          let index;
          if (event.key === 'ArrowRight') index = this.index + 1;
          if (event.key === 'ArrowLeft') index = this.index - 1;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this.tabs.length - 1;
          if (index === undefined) return;
          event.preventDefault();
          this.select(index, true);
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
          if (index !== -1) this.select(index);
        }, options);
      }
      select(index, focus = false) {
        if (!this.tabs.length) return;
        this.index = (index + this.tabs.length) % this.tabs.length;
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === this.index));
          tab.tabIndex = i === this.index ? 0 : -1;
          this.panels[i].hidden = i !== this.index;
        });
        if (focus) this.tabs[this.index].focus();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-real-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('star-real-videos')) {
    customElements.define('star-real-videos', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort(); this.abort = new AbortController(); const options = {signal:this.abort.signal};
        this.track = this.querySelector('.srv__track'); this.cards = [...this.querySelectorAll('[data-card]')];
        this.dialog = this.querySelector('dialog'); this.player = this.querySelector('.srv__player');
        this.soundButton = this.dialog.querySelector('[data-sound]');
        this.retryButton = this.dialog.querySelector('[data-retry]');
        this.playbackStatus = this.dialog.querySelector('.srv__playback-status');
        this.addEventListener('click', event => {
          const play = event.target.closest('[data-play]');
          const direction = event.target.closest('[data-direction]');
          const jump = event.target.closest('[data-jump]');
          if(play && !play.disabled) this.openClip(play.dataset.play,play);
          if(direction) this.scrollToCard(this.nearest()+Number(direction.dataset.direction));
          if(jump) this.scrollToCard(this.cards.findIndex(card=>card.dataset.card===jump.dataset.jump));
          if(event.target.closest('[data-sound]')) this.toggleSound();
          if(event.target.closest('[data-retry]')) this.playCurrent();
          if(event.target.closest('[data-close]')) this.dialog.close();
        },options);
        this.track.addEventListener('keydown',event=>{
          if(event.target!==this.track)return;
          if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
          event.preventDefault();
          this.scrollToCard(event.key==='Home'?0:event.key==='End'?this.cards.length-1:this.nearest()+(event.key==='ArrowRight'?1:-1));
        },options);
        this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());},options);
        this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();},options);
        this.dialog.addEventListener('close',()=>{this.stop();this.opener?.focus({preventScroll:true});},options);
        document.addEventListener('visibilitychange',()=>{if(document.hidden)this.player.querySelector('video')?.pause();},options);
        window.addEventListener('pagehide',()=>this.stop(),options);
        document.addEventListener('play',event=>{const current=this.player.querySelector('video');if(this.dialog.open&&current&&event.target.tagName==='VIDEO'&&event.target!==current)event.target.pause();},{...options,capture:true});
        document.addEventListener('shopify:block:select',event=>{const index=this.cards.findIndex(card=>card.dataset.card===event.detail.blockId);if(index>=0)this.scrollToCard(index);},options);
        this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.update();
      }
      nearest(){const left=this.track.getBoundingClientRect().left;let index=0,min=Infinity;this.cards.forEach((card,i)=>{const distance=Math.abs(card.getBoundingClientRect().left-left);if(distance<min){min=distance;index=i;}});return index;}
      scrollToCard(index){const card=this.cards[Math.max(0,Math.min(index,this.cards.length-1))];if(!card)return;this.track.scrollBy({left:card.getBoundingClientRect().left-this.track.getBoundingClientRect().left-4,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
      update(){const index=this.nearest();this.querySelectorAll('[data-jump]').forEach(button=>button.setAttribute('aria-current',String(button.dataset.jump===this.cards[index]?.dataset.card)));const max=this.track.scrollWidth-this.track.clientWidth;this.querySelector('[data-direction="-1"]').disabled=this.track.scrollLeft<4;this.querySelector('[data-direction="1"]').disabled=this.track.scrollLeft>=max-4;}
      openClip(id,opener){
        const template=[...this.querySelectorAll('template[data-clip]')].find(item=>item.dataset.clip===id);if(!template?.content.querySelector('video'))return;
        document.querySelectorAll('video').forEach(video=>video.pause());this.stop();this.opener=opener;
        this.dialog.querySelector('h3').textContent=template.dataset.title;
        this.dialog.querySelector('.srv__dialog-description').textContent=template.dataset.description;
        const error=this.dialog.querySelector('.srv__error');error.hidden=true;
        const content=template.content.cloneNode(true),video=content.querySelector('video');
        video.muted=matchMedia('(max-width: 749px)').matches;
        video.defaultMuted=video.muted;
        video.setAttribute('aria-label',template.dataset.title);
        video.addEventListener('volumechange',()=>this.updateSoundButton());
        video.addEventListener('playing',()=>{if(this.player.querySelector('video')!==video)return;clearTimeout(this.playTimer);this.playbackStatus.hidden=true;this.retryButton.hidden=true;});
        video.addEventListener('error',()=>{if(this.player.querySelector('video')!==video)return;clearTimeout(this.playTimer);error.textContent=this.dataset.error;error.hidden=false;this.playbackStatus.hidden=true;this.retryButton.hidden=true;},{once:true});
        this.player.append(content);
        this.retryButton.hidden=true;
        this.playbackStatus.hidden=true;
        this.updateSoundButton();
        if(!this.dialog.open)this.dialog.showModal();
        this.playCurrent();
        this.dialog.querySelector('[data-close]').focus();
      }
      playCurrent(){
        const video=this.player.querySelector('video');if(!video)return;
        this.retryButton.hidden=true;this.playbackStatus.hidden=false;
        clearTimeout(this.playTimer);
        this.playTimer=setTimeout(()=>{if(this.player.querySelector('video')===video&&video.paused){this.playbackStatus.hidden=true;this.retryButton.hidden=false;}},5000);
        try { Promise.resolve(video.play()).catch(()=>{if(this.player.querySelector('video')!==video)return;clearTimeout(this.playTimer);this.playbackStatus.hidden=true;this.retryButton.hidden=false;}); }
        catch { clearTimeout(this.playTimer);this.playbackStatus.hidden=true;this.retryButton.hidden=false; }
      }
      toggleSound(){const video=this.player.querySelector('video');if(!video)return;video.muted=!video.muted;this.updateSoundButton();if(video.paused)this.playCurrent();}
      updateSoundButton(){const video=this.player.querySelector('video');if(!video)return;const soundOn=!video.muted;this.soundButton.textContent=soundOn?this.soundButton.dataset.soundOff:this.soundButton.dataset.soundOn;this.soundButton.setAttribute('aria-pressed',String(soundOn));}
      stop(){clearTimeout(this.playTimer);const video=this.player?.querySelector('video');if(video){video.pause();video.removeAttribute('src');video.querySelectorAll('source').forEach(source=>source.removeAttribute('src'));video.load();}this.player?.replaceChildren();if(this.retryButton)this.retryButton.hidden=true;if(this.playbackStatus)this.playbackStatus.hidden=true;}
      disconnectedCallback(){this.stop();if(this.dialog?.open)this.dialog.close();this.abort?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame);}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-scene-switcher"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('famiware-scene-switcher')) {
    customElements.define('famiware-scene-switcher', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.scenes = Array.from(this.querySelectorAll('[data-scene]'));
        this.choices = Array.from(this.querySelectorAll('[data-choice]'));
        this.current = 0;
        this.addEventListener('click', event => {
          const choice = event.target.closest('[data-choice]');
          const step = event.target.closest('[data-step]');
          if (choice) this.show(Number(choice.dataset.choice));
          if (step) this.show(this.current + Number(step.dataset.step));
        }, options);
        this.addEventListener('keydown', event => {
          if (!event.target.closest('[data-choice]')) return;
          const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          let next = this.current + (['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1);
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.scenes.length - 1;
          this.show(next);
          this.choices[this.current].focus();
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const scene = event.target.closest('[data-scene]');
          if (scene) this.show(Number(scene.dataset.scene));
        }, options);
      }
      disconnectedCallback() { if (this.controller) this.controller.abort(); }
      show(index) {
        if (!this.scenes.length) return;
        this.current = (index + this.scenes.length) % this.scenes.length;
        this.scenes.forEach((scene, i) => {
          scene.classList.toggle('is-active', i === this.current);
          scene.setAttribute('aria-hidden', String(i !== this.current));
        });
        this.choices.forEach((choice, i) => choice.setAttribute('aria-pressed', String(i === this.current)));
        this.querySelector('.fss__status').textContent = this.choices[this.current].textContent.trim() + '. ' + this.scenes[this.current].querySelector('.fss__copy').textContent.trim();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
